<template>
    <div>
      <van-action-sheet v-model="show" :title="$t('bind_inviter')" get-container="#app" :close-on-click-overlay="false">
        <div class="form-box">
          <van-field v-model="registerFormObj.inviteCode" required autofocus :placeholder="$t('Please_enter_the_invitation_code')" />
          <van-button type="info" @click="register" :disabled="!registerFormObj.inviteCode" block style="margin-top: 20px;">{{$t('confirm')}}</van-button>
        </div>
      </van-action-sheet>
      <van-action-sheet v-model="networkShow" :title="$t('select_Network')" get-container="#app" :close-on-click-overlay="false">
        <div class="content">
          <div v-for="elem of chains" @click="onSelectNetwork(elem)">
            <img :src="elem.icon" width="24">
            <span v-if="(elem.chainId === 1000 && !base58Addr) || (elem.chainId === 1 && !addr)" style="color: #999;">{{elem.name}} <span style="font-size: 12px;">- {{$t('unavailable')}}</span></span>
            <span v-else>{{ elem.name }}</span>
          </div>
        </div>
      </van-action-sheet>
    </div>
  </template>
  
  <script>
  import FingerprintJS from '@fingerprintjs/fingerprintjs'
  export default {
    name: 'registerDialog',
    data() {
      return {
        addr: '',
        base58Addr: '',
        networkShow: false,
        chains: [
          { name: 'Ethereum (ERC20)', icon: '/_media/ETH.svg', chainId: 1 },
          { name: 'Tron Network (TRC20)', icon: '/_media/TRX.webp', chainId: 1000 },
        ],
        show: false,
        registerFormObj: {
          chainId: 1000,
          addr: '',
          inviteCode: '',
          bfp: '',
        }
      }
    },
    mounted() {
      // this.registerFormObj.addr = window.tronWeb.defaultAddress.base58;
      FingerprintJS.load().then(fp => {
            fp.get().then(result => {
                this.registerFormObj.bfp = result.visitorId;
            });
      });
    },
    methods: {
      register() {
        this.apiV1({
            method: 'post',
            url: '/create',
            data: this.registerFormObj
        }).then(response => {
            const { success, data } = response.data;
            if (success) {
              localStorage.setItem('chainId', data.chainId);
              localStorage.setItem('addr', data.addr);
              localStorage.setItem('token', data.token);
              const a = document.createElement('a');
              a.href = '/recharge?type=2';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
        })
      },
      open(inviteCode, addr, base58Addr) {
        this.addr = addr;
        this.base58Addr = base58Addr;
        this.registerFormObj.inviteCode = inviteCode || '';
        // this.show = true;
        this.networkShow = true;
      },
      onSelectNetwork({ chainId }) {
        this.registerFormObj.chainId = chainId;
        if (chainId === 1) {
          this.registerFormObj.addr = this.addr;
        } else {
          this.registerFormObj.addr = this.base58Addr;
        }
        if (!this.registerFormObj.addr) {
          return;
        }
        this.networkShow = false;
        this.show = true;
      }
    }
  }
  </script>
  
  <style scoped lang="less">
  .form-box {
    padding: 30px;
  }
  .content {
    padding: 16px;
    font-size: 16px;
    div {
      height: 52px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        margin-right: 8px;
      }
    }
  }
  </style>
  